import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons';

import FilterTopbar from 'components/search_page/filter_topbar';
import FilterRow from 'components/search_page/filter_row';
import FilterButton from 'components/ui/filter_button';

import RelationshipFilterGroup from './relationship_filter_group';
import ContactsCurrentFiltersGroup from './contacts_current_filters_group';
import CompanyGroupFilter from '../companies/company_group_filter';
import PersonGroupFilter from '../people/person_group_filter';
import ContactsTagsFilter from './contacts_tags_filter';
import MobileFilterTopBar from './mobile_filter_topbar';

import {
  changeSearchText,
  clearFiltersIfEmpty,
  toggleRole
} from "../store/actions/query";

import { delayRetrieveRecords } from "../store/actions/search";

export class ContactFilterTopbar extends React.Component {
  static propTypes = {
    canAccessCrm: PropTypes.bool.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    contactCount: PropTypes.number,
    contactRoles: PropTypes.array.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    isCompany: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),
    retrieveRecords: PropTypes.func.isRequired,
    searchText: PropTypes.string.isRequired,
    selectedGroupCount: PropTypes.number,
    selectedGroups: PropTypes.arrayOf(PropTypes.object),
    selectedRoles: PropTypes.array.isRequired,
    toggleRole: PropTypes.func.isRequired,

    onChangeSearchText: PropTypes.func.isRequired
  };

  static defaultProps = {
    isCompany: false
  };

  componentDidMount() {
    const { retrieveRecords } = this.props;
    retrieveRecords();
  }

  handleClearFiltersIfEmpty = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleRoleChange = (e) => {
    this.props.toggleRole(e.target.value, e.target.checked);
    this.handleClearFiltersIfEmpty();
  };

  handleSearchChange = (e) => {
    this.props.onChangeSearchText(e.target.value);
    this.handleClearFiltersIfEmpty();
  };

  get groupFilterLabel() {
    const selectedGroups = this.props.selectedGroups;

    if (selectedGroups.length === 0) {
      return this.props.isCompany ? 'All Companies' : 'All Contacts';
    } else if (selectedGroups.length === 1) {
      return selectedGroups[0].name;
    } else {
      return `${selectedGroups.length} Groups`;
    }
  }

  render() {
    return (
      <>
        <FilterTopbar>
          <div>{this.renderFilters()}</div>
          <div className="d-none d-md-block">
            <div className="ms-2 container-fluid">
              <ContactsCurrentFiltersGroup />
            </div>
          </div>
        </FilterTopbar>
        <MobileFilterTopBar />
      </>
    );
  }

  renderFilters() {
    const {
      canAccessCrm,
      pageData,
      groups,
      searchText
    } = this.props;

    return (
      <FilterRow
        pageData={pageData}
        searchPlaceholder="Search by name or company"
        searchText={searchText}
        onSearchChange={this.handleSearchChange}
      >
        {canAccessCrm && (groups && groups.length > 0) && this.renderGroupButton()}
        {this.renderRelationshipButton()}
        <ContactsTagsFilter />
      </FilterRow>
    );
  }

  renderGroupFilterLabel() {
    let count;
    if (this.props.selectedGroups.length <= 1) {
      count = (
        <span className="ms-2">
          ({this.props.selectedGroupCount})
        </span>
      );
    }

    return (
      <>
        <FontAwesomeIcon
          className="me-2 folder-icon"
          icon={faFolderOpen}
        />
        <span className="group-text">
          {this.groupFilterLabel}
          {count}
        </span>
      </>
    );
  }

  renderGroupButton() {
    return (
      <FilterButton
        className="w-auto"
        filtersApplied={false}
        label={this.renderGroupFilterLabel()}
        name="groups-filter"
      >
        {this.props.isCompany ? <CompanyGroupFilter /> : <PersonGroupFilter />}
      </FilterButton>
    );
  }

  renderRelationshipButton() {
    const { contactRoles, selectedRoles } = this.props;

    return (
      <FilterButton
        className="w-auto"
        filtersApplied={selectedRoles.length > 0}
        label="Contact Type"
        name="relationship"
        popoverBodyClassName="overflow-y-auto"
      >
        <RelationshipFilterGroup
          roles={contactRoles}
          selected={selectedRoles}
          onChange={this.handleRoleChange}
        />
      </FilterButton>
    );
  }
}

const mapStateToProps = state => ({
  canAccessCrm: state.ui.canAccessCrm,
  contactRoles: state.static.contactRoles,
  searchText: state.query.searchText,
  selectedRoles: state.query.roles,
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  toggleRole,

  onChangeSearchText: changeSearchText
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactFilterTopbar);
